import React from "react";
import Index from "./index";
import OrderTable from "./OrderTable";

const Orders = () => {
    const { orders, loading, history, search, setSearch, dispatch } = Index();

    return (
        <OrderTable
            heading="All Orders"
            orders={orders}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            dispatch={dispatch}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Orders, comparisonFn);
